import NewsletterSection from '@/components/NewsletterSection'
import { getBlogs, getBlogCategories } from '@/lib/api'

export default async function BlogPage() {
  const [blogsData, categories] = await Promise.all([
    getBlogs({ page: 1, paginate: 10 }),
    getBlogCategories(),
  ])

  const fallbackBlogs: any[] = [
    { id: 1, slug: '1', title: 'Lorem ipsum dolor sit amet consectetur diam', image: '/investment-wealth.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [{ id: 1, name: 'Investment' }, { id: 2, name: 'Fundraising' }], description: 'Lorem ipsum dolor sit amet consectetu Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in.' },
    { id: 2, slug: '2', title: 'Lorem ipsum dolor', image: '/story-event.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [], description: '' },
    { id: 3, slug: '3', title: 'Lorem ipsum dolor', image: '/blog-homs.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [], description: '' },
    { id: 4, slug: '4', title: 'Lorem ipsum dolor', image: '/story-event.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [], description: '' },
    { id: 5, slug: '5', title: 'Lorem ipsum dolor', image: '/blog-homs.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [], description: '' },
    { id: 6, slug: '6', title: 'Lorem ipsum dolor sit amet consectetur diam', image: '/investment-wealth.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [{ id: 1, name: 'Fundraising' }, { id: 2, name: 'Investment' }], description: 'Lorem ipsum dolor sit amet consectetu Diam bibendum ut diam tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in. tempus sociis lectus luctus in? Lorem ipsum dolor sit amet consectetur Diam bibendum ut diam tempus sociis lectus luctus in.' },
    { id: 7, slug: '7', title: 'Lorem ipsum dolor', image: '/investment-wealth.jpg', created_at: '21-08-2024', likes_count: 23, comments_count: 5, categories: [{ id: 1, name: 'Investment' }, { id: 2, name: 'Fundraising' }], description: '' },
  ]
  const blogs = (blogsData?.blogs && blogsData.blogs.length > 0) ? blogsData.blogs : fallbackBlogs
  const pagination = blogsData?.pagination
  const cats = categories || []

  const ArrowBtn = () => (
    <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12,5 19,12 12,19"/></svg>
    </div>
  )

  const Tag = ({ label }: { label: string }) => (
    <span style={{ fontSize: '10px', fontWeight: 600, color: '#fff', background: 'rgba(30,50,120,0.85)', border: '1px solid rgba(80,100,200,0.5)', borderRadius: '3px', padding: '2px 8px' }}>{label}</span>
  )

  // Split blogs for the layout
  const large = blogs[0]
  const smallRight = blogs.slice(1, 3)
  const smallLeft = blogs.slice(3, 5)
  const largeRight = blogs[5]
  const wide = blogs[6]

  return (
    <>
      {/* HERO */}
      <section className="relative overflow-hidden" style={{ height: '340px', background: '#07090e' }}>
        <div style={{ position: 'absolute', left: '-20px', top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
          <img src="/ghassan-artistic.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(7,9,14,0.8) 0%, transparent 60%, rgba(7,9,14,0.4) 100%)' }} />
        </div>
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
          <img src="/ghassan-real.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(270deg, rgba(7,9,14,0.8) 0%, transparent 60%, rgba(7,9,14,0.4) 100%)' }} />
        </div>
        <div style={{ position: 'absolute', left: '18px', bottom: '-10px', zIndex: 2, fontSize: '220px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.08)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>Ch</div>
        <div style={{ position: 'absolute', right: '24px', top: '20px', zIndex: 2, fontSize: '160px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.07)', lineHeight: 1, pointerEvents: 'none', userSelect: 'none' }}>R</div>
        <div style={{ position: 'absolute', inset: 0, zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h1 style={{ fontSize: '42px', fontWeight: 900, color: '#fff', letterSpacing: '0.12em' }}>OUR BLOG</h1>
        </div>
        <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 20, width: '48px', height: '48px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 16px rgba(249,115,22,0.45)' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
      </section>

      {/* RECENT BLOG POSTS + FILTERS */}
      <section style={{ background: '#07090e', padding: '56px 0 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 900, color: '#fff', textAlign: 'center', letterSpacing: '0.14em', marginBottom: '40px' }}>RECENT BLOG POSTS</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '36px' }}>
            {[
              { label: 'Falter by date:', placeholder: 'mm/dd/yy' },
              { label: 'Filter by Category:', placeholder: 'All Categories', options: cats },
              { label: 'Filter by Status:', placeholder: 'All Status' },
            ].map((f, i) => (
              <div key={i}>
                <label style={{ display: 'block', fontSize: '12px', color: 'rgba(255,255,255,0.70)', marginBottom: '6px' }}>{f.label}</label>
                <div style={{ position: 'relative' }}>
                  <select style={{ width: '100%', padding: '10px 36px 10px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)', borderRadius: '4px', color: 'rgba(255,255,255,0.60)', fontSize: '12px', appearance: 'none', cursor: 'pointer', outline: 'none' }}>
                    <option>{f.placeholder}</option>
                    {f.options?.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2"><polyline points="6,9 12,15 18,9"/></svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BLOG GRID */}
      <section style={{ background: '#07090e', padding: '0 0 60px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 32px' }}>

          {/* ROW 1 */}
          {blogs.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              {large && (
                <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', minHeight: '420px', cursor: 'pointer' }}>
                  <img src={large.image} alt={large.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                  <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', gap: '6px', zIndex: 2 }}>
                    {large.categories?.map(c => <Tag key={c.id} label={c.name} />)}
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(255,255,255,0.92)', padding: '16px 16px 12px', zIndex: 2 }}>
                    <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#111', marginBottom: '4px', lineHeight: 1.4 }}>{large.title}</h3>
                    <p style={{ fontSize: '11px', color: '#888', marginBottom: '10px' }}>{large.created_at}</p>
                    <p style={{ fontSize: '11.5px', color: '#555', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: large.description?.replace(/<[^>]*>/g,'').slice(0,160) + '...' }} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}><ArrowBtn /></div>
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {smallRight.map(post => (
                  <div key={post.id} style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '200px', cursor: 'pointer' }}>
                    <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.75) 100%)' }} />
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                      <div>
                        <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>{post.title}</h3>
                        <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>{post.created_at}</p>
                      </div>
                      <ArrowBtn />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ROW 2 */}
          {blogs.length > 3 && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {smallLeft.map(post => (
                  <div key={post.id} style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden', flex: 1, minHeight: '195px', cursor: 'pointer' }}>
                    <img src={post.image} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 25%, rgba(0,0,0,0.78) 100%)' }} />
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                      <div>
                        <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#fff', marginBottom: '3px' }}>{post.title}</h3>
                        <p style={{ fontSize: '10px', color: 'rgba(255,255,255,0.60)' }}>{post.created_at}</p>
                      </div>
                      <ArrowBtn />
                    </div>
                  </div>
                ))}
              </div>
              {largeRight && (
                <div style={{ borderRadius: '8px', overflow: 'hidden', position: 'relative', minHeight: '402px', cursor: 'pointer' }}>
                  <img src={largeRight.image} alt={largeRight.title} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }} />
                  <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', flexDirection: 'column', gap: '5px', zIndex: 2, alignItems: 'flex-end' }}>
                    {largeRight.categories?.map(c => <Tag key={c.id} label={c.name} />)}
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(255,255,255,0.92)', padding: '16px', zIndex: 2 }}>
                    <p style={{ fontSize: '11.5px', color: '#555', lineHeight: 1.75, marginBottom: '10px' }} dangerouslySetInnerHTML={{ __html: largeRight.description?.replace(/<[^>]*>/g,'').slice(0,200) + '...' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                      <div>
                        <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#111', marginBottom: '3px' }}>{largeRight.title}</h3>
                        <p style={{ fontSize: '11px', color: '#999' }}>{largeRight.created_at}</p>
                      </div>
                      <ArrowBtn />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ROW 3 wide */}
          {wide && (
            <div style={{ borderRadius: '8px', overflow: 'hidden', position: 'relative', height: '280px', cursor: 'pointer', marginBottom: '40px' }}>
              <img src={wide.image} alt={wide.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.55) 100%)' }} />
              <div style={{ position: 'absolute', top: '14px', right: '14px', display: 'flex', gap: '6px', zIndex: 2 }}>
                {wide.categories?.map(c => <Tag key={c.id} label={c.name} />)}
              </div>
              <div style={{ position: 'absolute', bottom: '16px', right: '16px', zIndex: 2 }}><ArrowBtn /></div>
            </div>
          )}

          {/* PAGINATION */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', paddingBottom: '20px' }}>
            {Array.from({ length: Math.min(pagination?.total_pages || 4, 4) }, (_, i) => i + 1).concat(['...', pagination?.total_pages || 10] as any).map((p, i) => (
              <button key={i} style={{ width: p === '...' ? 'auto' : '32px', height: '32px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 600, background: p === 1 ? '#f97316' : 'transparent', color: p === 1 ? '#fff' : 'rgba(255,255,255,0.60)', padding: p === '...' ? '0 4px' : '0' }}>{p}</button>
            ))}
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
